import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

function getTags() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/tags`, requestOptions).then(handleResponse);
}

function addOrUpdateTags(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/tags`, requestOptions).then(handleResponse);
}

function deleteTag(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/tags/${id}`, requestOptions).then(handleResponse);
}

export const conversationTagsService = {
    getTags,
    addOrUpdateTags,
    deleteTag,
};
